import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse/types'
import { TopComplaints, getTopComplaints } from 'api/pulse/topComplaints'
import { getTopComplaintsKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useTopComplaints(query: PulsePaginatedFilters) {
  return useInfiniteQuery<TopComplaints>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getTopComplaintsKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getTopComplaints(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
